// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__R7Y8f","colMin":"styles_colMin__fpP5U"};